import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useRoleFormState() {
  return useAppState();
}

export function useRoleFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      roleForm: {
        groupId: '',
        roleName: '',
      },
    }));
  }

  function updateForm(role) {
    dispatch((state) => ({
      ...state,
      roleForm: role,
    }));
  }

  function updateGroupId(groupId) {
    dispatch((state) => ({
      ...state,
      roleForm: {
        ...state.roleForm,
        groupId,
      },
    }));
  }

  function updateRoleName(roleName) {
    dispatch((state) => ({
      ...state,
      roleForm: {
        ...state.roleForm,
        roleName,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    updateForm,
    updateGroupId,
    updateRoleName,
    onResponse,
    onError,
    clearFeedback,
  };
}
